import React, { useEffect, useState, useRef } from 'react';
import { IoChevronDown, IoChevronForward } from 'react-icons/io5';
import { Tooltip } from 'ui-controls';
import './styles.css';

const DropdownMenu = ({
  options = [],
  defaultSelected = '',
  onSelect,
  placeholder = 'Select an option',
  className = '',
  dropdownClassName = '',
  menuClassName = '',
  width = '16rem',
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(defaultSelected);
  const dropdownRef = useRef();

  // Update selectedOption when defaultSelected changes
  useEffect(() => {
    setSelectedOption(defaultSelected);
  }, [defaultSelected]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleOptionClick = (option) => {
    setSelectedOption(option.label);
    onSelect?.(option); // Call onSelect if provided
    setIsOpen(false);
  };

  return (
    <div
      className={`dropdown-container-component ${className}`}
      ref={dropdownRef}
    >
      <div
        className={`dropdown-trigger-component clickable ${dropdownClassName}`}
        onClick={() => options.length > 0 && setIsOpen(!isOpen)}
        style={{ width: width }}
      >
        <Tooltip delay={500} label={<div>{selectedOption || placeholder}</div>}>
          <div className="dropdown-text-component">
            {selectedOption || placeholder}
          </div>
        </Tooltip>
        {options.length > 0 && (
          <div className="dropdown-icon-component">
            {isOpen ? <IoChevronDown /> : <IoChevronForward />}
          </div>
        )}
      </div>
      {isOpen && (
        <div
          className={`dropdown-menu-component ${menuClassName}`}
          style={{ width: width }}
        >
          {options.map((option, index) => (
            <div
              key={index}
              className="menuItem"
              onClick={() => handleOptionClick(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DropdownMenu;
